import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Pages from '../../Router/pages';
import WithdawalsModal from '../../templates/WithdawalsModal';
import { isActivePage } from '../utils/isActivePage';
import CoinsInfo from './CoinsInfo';
import EnergyInfo from './EnergyInfo';
import RocketBalance from './RocketBalance';
import UsdtBalance from './UsdtBalance';
import UserLeague from './UserLeague';

type TModalType = 'withdraw'

const energyInfoPages: string[] = [Pages.quests, Pages.boosters, Pages.store];
const userLeaguePages: string[] = [Pages.home, Pages.friends, Pages.boosters];
const usdtBalancePages: string[] = [Pages.chests, Pages.chest()];
const rocketBalancePages: string[] = [Pages.chests, Pages.home, Pages.leaderbord, Pages.chest(), Pages.upgrade, Pages.dropBank];
const coinsInfoPages: string[] = [Pages.home, Pages.quests, Pages.leaderbord, Pages.friends, Pages.boosters, Pages.upgrade, Pages.store, Pages.dropBank];

function Header() {
  const location = useLocation();

  const [modal, setModal] = useState<TModalType>();

  const isUserLeagueDisplayed = isActivePage(`${location.pathname}`, userLeaguePages);
  const isEnergyInfoDisplayed = isActivePage(`${location.pathname}`, energyInfoPages);
  const isUsdtBalanceDisplayed = isActivePage(`${location.pathname}`, usdtBalancePages);
  const isRocketBalanceDisplayed = isActivePage(`${location.pathname}`, rocketBalancePages);
  const isCoinsInfoDisplayed = isActivePage(`${location.pathname}`, coinsInfoPages);
  const onOpen = () => {
    setModal('withdraw');
  };

  const onClose = () => {
    setModal(undefined);
  };

  return (
    <>
      <div
        id="header"
        className="py-2 flex justify-between items-end pr-4 pl-4 text-white text-xs z-[1500] relative w-full"
      >
        <div
          className="w-full rounded-[14px] bg-[#1212141F] border-[#ffffff33] border-[0.5px] flex justify-between py-3 px-[8px] overflow-hidden"
          style={{
            backdropFilter: 'blur(40px)',
          }}
        >
          {isUserLeagueDisplayed && <UserLeague />}
          {isEnergyInfoDisplayed && <EnergyInfo />}
          {isRocketBalanceDisplayed && <RocketBalance />}
          {isUsdtBalanceDisplayed && <UsdtBalance onClick={onOpen} />}
          {isCoinsInfoDisplayed && <CoinsInfo />}
        </div>
      </div>
      <WithdawalsModal open={modal === 'withdraw'} onClose={onClose} />
    </>
  );
}
export default Header;
